module.exports = __webpack_public_path__ + "img/fd_notjoin_img.3dc9465a.png";